import PreviewContainer from '../../../Carousel/Preview';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Typography } from '@material-ui/core';
import Card from '../../Card';
import { IShowcaseSchool } from 'interface/showcase';
import { sendElastic } from 'actionCreators/judasLog';
import { v4 } from 'uuid';
import useImageFallback from 'hooks/useImageFallback';

interface IProps {
  school: IShowcaseSchool;
}

const useStyles = makeStyles((theme) => ({
  image: {
    paddingTop: '42.83%',
    '@media(max-width: 1024px)': {
      minHeight: 78,
      maxHeight: 78,
    },
  },
  textButton: {
    color: theme.palette.primary.light,
    marginTop: theme.spacing(2),
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.main,
    },
    '&:active': {
      color: theme.palette.primary.dark,
    },
  },
}));

const SchoolCard = (props: IProps) => {
  const classes = useStyles();
  const imageProps = useImageFallback(props.school.image ?? props.school.old_image);

  const openSchool = () => {
    const link = props.school.domain ?? props.school.subdomain;
    sendElastic('clickSchool', `Clicou na escola com subdomínio: ${link} (${props.school.id})`);
    window.open(link);
  };
  const uuid = v4();
  const defaultProps = {
    classes: {
      image: classes.image,
    },
    onClick: openSchool,
    title: props.school.title,
    id: props.school.id,
    ...imageProps,
  };

  return (
    <>
      <PreviewContainer.Iddle onClick={openSchool} onTouch={openSchool} id={uuid}>
        <Card {...defaultProps} />
      </PreviewContainer.Iddle>
      <PreviewContainer.Active id={uuid}>
        <Card {...defaultProps}>
          <Typography variant='body1' component='span'>
            {props.school.title}
          </Typography>
          <Typography onClick={openSchool} className={classes.textButton} variant='body2'>
            Acesse seus cursos clicando aqui
          </Typography>
        </Card>
      </PreviewContainer.Active>
    </>
  );
};

export default SchoolCard;
